import { Link } from "react-router-dom";
import { Play } from "lucide-react";

const VideoCard = ({ article, className = "" }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  };

  return (
    <Link
      to={`/article/${article.slug}`}
      className={`editorial-card block group ${className}`}
      data-testid={`video-card-${article.slug}`}
    >
      <div className="editorial-image-wrapper aspect-video mb-4 relative">
        <img
          src={article.image_url}
          alt={article.title}
          className="editorial-card-image"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors">
          <div className="w-14 h-14 border-2 border-white flex items-center justify-center group-hover:bg-white group-hover:text-black transition-all duration-300">
            <Play className="w-5 h-5 text-white group-hover:text-black ml-0.5" fill="currentColor" />
          </div>
        </div>
      </div>
      <div className="space-y-2">
        <h3 className="font-serif text-lg font-semibold text-white line-clamp-2 group-hover:text-wine-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-neutral-400 text-sm line-clamp-2">
          {article.excerpt}
        </p>
        <div className="flex items-center gap-3 text-neutral-500 text-xs pt-1">
          <span>{article.author}</span>
          <span className="w-1 h-1 rounded-full bg-neutral-600"></span>
          <span>{formatDate(article.published_at)}</span>
        </div>
      </div>
    </Link>
  );
};

export default VideoCard;
